import React, { useState } from "react";
import { useGet } from "../../common/hooks";
import { Division, Game } from "../../common/interfaces";
import { Button, Divider, Select } from "antd";
import { allKnownDivisions, dtNow, formatISODate, getDivisionName } from "../../common/utils";
import { CompactTable } from "../../common/components/CompactTable";
import { Link } from "react-router-dom";
import { GoalieAssignUrl } from "../routes";
import _ from "lodash";

export function GoalieAssignmentSeason() {
  const [division, setDivision] = useState<Division | undefined>(undefined);
  const games = useGet<Game[]>(division !== undefined ? "/api/games" : undefined);

  const upcomingGames = _.sortBy(
    (games.data || []).filter(g => g.date > dtNow() && (!division || g.division === division)),
    g => g.date
  );

  const columns = [
    { dataIndex: "rinkName", title: "Rink" },
    { dataIndex: "date", title: "Date/Time", render: (val: string) => formatISODate(val) },
    { dataIndex: "team1Name", title: "Home Team" },
    { dataIndex: "team1GoalieName", title: "Home Goalie", render: (val?: string) => val || "—" },
    { dataIndex: "team2Name", title: "Away Team" },
    { dataIndex: "team2GoalieName", title: "Away Goalie", render: (val?: string) => val || "—" },
    {
      key: "assign",
      title: "",
      render: (_: any, row: Game) => (
        <Link to={GoalieAssignUrl.createUrl(row.id)}>
          <Button size="small">Assign Goalies</Button>
        </Link>
      )
    }
  ];

  return (
    <>
      <Divider>Assign Goalies</Divider>
      <Select
        placeholder="Filter by division"
        allowClear
        style={{ width: 180, marginBottom: 16 }}
        onChange={(val: Division) => setDivision(val)}
        onClear={() => setDivision(undefined)}
      >
        {allKnownDivisions.map(d => (
          <Select.Option key={d} value={d}>{getDivisionName(d)}</Select.Option>
        ))}
      </Select>
      <CompactTable
        data={upcomingGames}
        columns={columns}
        loading={games.isLoading}
      />
    </>
  );
}
